export default "__VITE_ASSET__CYfGIFd5__"